import PreferencesSettingsTheme from './PreferencesSettingsTheme';

export default PreferencesSettingsTheme;
